import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './hooks/useAuth';
import ProtectedRoute from './components/ProtectedRoute';
import Home from './components/Home';
import About from './components/About';
import Beauty from './components/Beauty';
import Retratos from './components/Retratos';
import Login from './admin/Login';
import Dashboard from './admin/Dashboard';

export default function App() {
  return (
    <AuthProvider>
      <Router>
        <Routes>
          {/* Rutas públicas del portfolio */}
          <Route path='/' element={<Home />} />
          <Route path='beauty' element={<Beauty />} />
          <Route path='retratos' element={<Retratos />} />
          <Route path='about' element={<About />} />

          {/* Rutas de administración */}
          <Route path='admin/login' element={<Login />} />
          <Route
            path='admin'
            element={
              <ProtectedRoute>
                <Dashboard />
              </ProtectedRoute>
            }
          />
        </Routes>
      </Router>
    </AuthProvider>
  );
}
